import { useSearchParams } from "react-router-dom"

import {
  PAGE_NUMBER,
  QUERY,
  getTimeRangeFiltersValues
} from "@/helpers/filters.helper"

export const useQueryString = (
  additionParamKeys?: (string | { key: string })[]
): { pageNumber: string } & Record<string, string | undefined> => {
  const [searchParams] = useSearchParams()

  const result = {
    pageNumber: searchParams.get(PAGE_NUMBER) || "0",
    query: searchParams.get(QUERY) || undefined,
    ...additionParamKeys?.reduce(
      (acc, item) => {
        const key = typeof item === "string" ? item : item.key
        const value = searchParams.get(key)

        if (value) {
          acc[key] = value
        }

        return acc
      },
      {} as Record<string, string>
    )
  }

  if (!result.query) {
    delete result.query
  }

  return getTimeRangeFiltersValues(result)
}
